module.exports = (Promise.resolve(__parcel__require__("./" + "RistrettoPlaying.424f9449.df46d42d.js"))).then(() => parcelRequire('k84Vs'));